import * as React from 'react';
import {Header} from "./sharedComponents/Header";
import {Footer} from "./sharedComponents/Footer";
import {SkipLink} from "./a11y/SkipLink";
import {usePageTitle} from "../utilities/usePageTitle";

interface Props {
    active: string,
    title: string,
    children: any
}

export const Main = (props: Props) => {
    usePageTitle(props.title);

    return <>
        <SkipLink/>
        <Header active={props.active}/>
        <main id={'tresc'} tabIndex={-1} className={'container'}>
            <div className={'containerm'}>
                {props.children}
            </div>
        </main>
        <Footer/>
    </>
}

export default Main
